/**
 * Styled Components - Created by david on 09/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
`

export const Text = styled.div`
  color: cornflowerblue;
  font-size: 14px;
  line-height: 22px;
  margin-right: 8px;
  background: white;
  z-index: 2;
  border-radius: 3px;
  padding: 1px 4px;
  border: 1px solid cornflowerblue;
  &:hover {
    cursor: pointer;
  }
`

export const NextIcon = styled.img``



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SeeAllButton/styledComponents.tsx